import Button from "react-bootstrap/Button";

export const ButtonModalClose = ({ close, buttonText, className = "w-50" }) => {
  return (
    <Button
      className={className}
      variant="secondary"
      type="submit"
      onClick={() => close(false)}
    >
      {buttonText}
    </Button>
  );
};
